import { FileText, Info, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { GlassCard, Field } from "@/components/erp";
import { SelectBox } from "@/components/Inputs";
import { TarihInput } from "@/components/TarihInput";
import { PARA } from "@/lib/perms";
import { sablonlar, sablonKaydet } from "@/lib/satisBelge";

export const Kart = ({ ikon: I, baslik, alt, sag, children, testid }) => (
  <GlassCard className="p-0 overflow-visible" data-testid={testid}>
    <div className="flex items-center gap-3 px-5 py-4 border-b border-white/10">
      <I className="w-5 h-5 text-muted-foreground" />
      <div className="flex-1 min-w-0"><div className="font-semibold">{baslik}</div>{alt && <div className="text-[11px] text-muted-foreground">{alt}</div>}</div>
      {sag}
    </div>
    <div className="p-5">{children}</div>
  </GlassCard>
);

const Etiket = ({ children, ek }) => <div className="flex items-center justify-between gap-2"><span>{children}</span>{ek}</div>;

const adresMetni = (a) => [a.adres, a.ilce, a.il, a.ulke].filter(Boolean).join(" - ");

export const GenelBilgiler = ({ cfg, f, set, cariler, cari, seriNo, onHizliCari, kurDegis }) => {
  const adresler = (cari?.adresler?.length ? cari.adresler : cari ? [{ adres: cari.adres, il: cari.il, ilce: cari.ilce }] : []).map(adresMetni).filter(Boolean);
  const [ik, ikEtiket] = cfg.ikinci;
  const sb = sablonlar();
  return (
    <Kart ikon={FileText} baslik="Genel Bilgiler" testid="belge-genel">
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label={<Etiket ek={<button type="button" data-testid="belge-hizli-cari" onClick={onHizliCari} className="text-xs inline-flex items-center gap-0.5 hover:text-[var(--g1)]"><Plus className="w-3 h-3" />Hızlı Ekle</button>}>Cari *</Etiket>}>
          <SelectBox testid="belge-cari" value={f.cari_id} onChange={(v) => set("cari_id", v)} options={cariler.map((c) => ({ value: c.id, label: `${c.kod} - ${c.unvan}` }))} />
        </Field>
        <Field label="Cari Adresi">
          <SelectBox testid="belge-adres" value={f.teslim_adresi} onChange={(v) => set("teslim_adresi", v)} placeholder={cari ? "Adres seçin" : "Önce cari seçin"} options={adresler.map((a) => ({ value: a, label: a }))} />
        </Field>
        <Field label={`${cfg.tarihEtiket} *`}><TarihInput data-testid="belge-tarih" value={f.tarih} onChange={(e) => set("tarih", e.target.value)} className="bg-white/5" /></Field>
        <Field label={<span className="inline-flex items-center gap-1">Seri Numarası <Info className="w-3 h-3" /></span>}>
          <div data-testid="belge-seri-no" className="h-10 px-3 flex items-center rounded-md border border-white/10 bg-white/5 font-mono font-semibold">{seriNo || "…"}</div>
        </Field>
        <Field label={ikEtiket} className={cfg.saat ? "" : "sm:col-span-2"}><TarihInput data-testid={`belge-${ik}`} value={f[ik]} onChange={(e) => set(ik, e.target.value)} className="bg-white/5" /></Field>
        {cfg.saat && <Field label="Sevkiyat Saati *"><Input data-testid="belge-sevk-saati" type="time" value={f.sevk_saati} onChange={(e) => set("sevk_saati", e.target.value)} className="bg-white/5" /></Field>}
        <Field label="Para birimi"><SelectBox testid="belge-para" value={f.para_birimi} onChange={kurDegis} options={PARA} /></Field>
        <Field label="Takip Para Birimi"><SelectBox testid="belge-takip-para" value={f.takip_para_birimi} onChange={(v) => set("takip_para_birimi", v)} options={PARA} /></Field>
        {f.para_birimi !== "TRY" && <Field label="Döviz Kuru"><Input data-testid="belge-kur" type="number" step="any" value={f.kur} onChange={(e) => set("kur", Number(e.target.value))} className="bg-white/5" /></Field>}
      </div>
      <div className="grid sm:grid-cols-3 gap-4 mt-4">
        <Field label="Açıklama Şablonları">
          <SelectBox testid="belge-sablon" value="" onChange={(v) => set("aciklama", v)} placeholder={sb.length ? "Şablon seçin" : "Kayıtlı şablon yok"} options={sb.map((s) => ({ value: s, label: s.slice(0, 60) }))} />
        </Field>
        <Field label={<Etiket ek={f.aciklama.trim() && <button type="button" data-testid="belge-sablon-kaydet" onClick={() => sablonKaydet(f.aciklama.trim())} className="text-xs hover:text-[var(--g1)]">Şablon olarak kaydet</button>}>Açıklama</Etiket>} className="sm:col-span-2">
          <Textarea data-testid="belge-aciklama" rows={3} value={f.aciklama} onChange={(e) => set("aciklama", e.target.value)} className="bg-white/5" />
        </Field>
      </div>
    </Kart>
  );
};
